/*jshint esversion: 6 */

import React from 'react';

const CaAccountFormView = props => {

    const {
        onSubmit,
        submitCta,
        formFieldsData,
        selectData,
        onFieldChange,
        onSelectChange,
        checkboxData,
        onCheckboxChange,
        successMessage,
        errorMessage,
        forgotPasswordNav,
        forgotPasswordText

    } = props;

    let allfields = [];
    if ( formFieldsData ) allfields = allfields.concat(formFieldsData);
    if ( selectData ) allfields.push(selectData);
    if ( checkboxData ) allfields.push(checkboxData);

    return (
        <form>
            {!!formFieldsData && formFieldsData.map((item,index)=>(
                <div
                    key={index}
                    className="AccountModal__input">
                    <input
                        ref={(input) => {item.ref = input }}
                        className={item.validateItem&&!item.valid?'invalid':''}
                        onChange={(e)=>onFieldChange(e,allfields)}
                        type={item.type}
                        placeholder={item.placeholder}
                        id={item.id}
                        value={!!item.value?item.value:""}
                    />
                </div>
            ))}
            {!!forgotPasswordNav &&
            <p>
                <a href={"#"} onClick={(e) => forgotPasswordNav(e)}>{forgotPasswordText}</a>
            </p>
            }

            { !!selectData &&
                <div className="AccountModal__input">
                    <select id={selectData.id} ref={(input) => {selectData.ref = input }} onChange={(e)=>onSelectChange(e,allfields)} value={selectData.value}>
                        {selectData.data.map(item => <option key={item.value} value={item.value}>{item.label}</option>)}
                    </select>
                </div>
            }
            <div className={"AccountModal__form-row"}>
                <div className={"AccountModal__form-col"}>
                    <button onClick={(e)=>onSubmit(e,allfields)}>{submitCta}</button>
                </div>
                {!!checkboxData &&
                    <div className={"AccountModal__form-col"}>
                        <input ref={(input) => {checkboxData.ref = input }}
                               id={checkboxData.id}
                               checked={checkboxData.value}
                               onChange={(e) => onCheckboxChange(e,allfields)} type="checkbox"
                               name={checkboxData.id} />
                        <label className={checkboxData.validateItem && !checkboxData.valid ? 'invalid' : ''} htmlFor={checkboxData.id}>
                            <a target="_blank" href={checkboxData.link}>{checkboxData.label}</a>
                        </label>
                    </div>
                }
            </div>
            <div className={"AccountModal__post-messageWrapper"}>
                {successMessage && (<p className="AccountModal__post-message AccountModal__post-message--success">{successMessage}</p>)}
                {errorMessage && (<p className="AccountModal__post-message AccountModal__post-message--error">{errorMessage}</p>)}
            </div>
        </form>

    )
}

export default CaAccountFormView;